import Icon from '../components/Icon.vue'

Icon.register({"brush":{"width":384,"height":512,"paths":[{"d":"M352 0H32C14.3 0 0 14.3 0 32V256H384V32C384 14.3 369.7 0 352 0zM0 320C0 355.4 28.7 384 64 384H128V448C128 483.4 156.7 512 192 512S256 483.4 256 448V384H320C355.3 384 384 355.4 384 320V288H0V320zM192 424C205.3 424 216 434.7 216 448 216 461.3 205.3 472 192 472S168 461.3 168 448C168 434.7 178.8 424 192 424z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brush.js
// module id = null
// module chunks = 